

export default function NotFound(){
    return <>

    <div>not Found</div>
        </>
}